import * as React from 'react';

import { withStyles, createStyles } from '@material-ui/core/styles';

import { SettingSection } from '../../widgets/setting-section';

const styles = () => createStyles({});

export interface JobFieldProps {
  /**
   * The view that is used to edit this Job field. Typically is just some mix of <Field /> components
   */
  editView?: React.ReactNode;

  /**
   * The view that should be used ot view the Job field.
   */
  displayView?: React.ReactNode;

  headerActions?: React.ReactNode;
  isEditing?: boolean;
  title?: string | null;
  caption?: React.ReactNode | string | null;
  showSettingSection?: boolean;
  showHeader?: boolean;
}

/**
 * This component abstracts the common concerns of the job fields, specifically:
 *  - specifying custom header actions
 *  - displaying the raw inputs or a wrapped SettingSection
 *  - a view vs. edit mode
 *
 * The only required prop is the editView.
 */
class JobFieldComponent extends React.PureComponent<JobFieldProps> {
  renderSettingSection = () => {
    const {
      displayView,
      editView,

      isEditing,
      headerActions,
      title,
      caption,
      showHeader,
    } = this.props;
    const showEditingView = typeof isEditing === 'undefined' || isEditing;

    return (
      <SettingSection
        title={!showHeader && showHeader !== undefined ? null : title}
        caption={!showHeader && showHeader !== undefined ? null : caption}
        headerActions={headerActions}
      >
        {!showEditingView && displayView ? displayView : editView}
      </SettingSection>
    );
  };

  renderJustView = () => {
    const {
      displayView,
      editView,

      isEditing,
    } = this.props;
    const showEditingView = typeof isEditing === 'undefined' || isEditing;

    return !showEditingView && displayView ? displayView : editView;
  };

  render() {
    const { showSettingSection } = this.props;
    const shouldShowSettingSection =
      typeof showSettingSection === 'undefined' || showSettingSection;
    return shouldShowSettingSection ? this.renderSettingSection() : this.renderJustView();
  }
}

export const JobField = withStyles(styles)(JobFieldComponent);
